import React from "react";
import PayrollRomms from "../../payroll/PayrollRomms";

interface CCERommsProps {
  onBack: () => void;
}

export default function CCERomms({ onBack }: CCERommsProps) {
  return <PayrollRomms onBack={onBack} onComplete={() => {}} workspace="Cash & Cash Equivalents" />;
}



